import { render } from "./RecentOperations.vue?vue&type=template&id=22dbea11"
import script from "./RecentOperations.vue?vue&type=script&lang=js"
export * from "./RecentOperations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__